import {
    ArrowLeft,
    ArrowRight,
    Icon,
    LabelRegular,
    View,
    XStack,
} from 'smoothie';

export const SlideNav = ({
    index,
    onNext,
    onPrevious,
    slideCount,
    lastIndex,
}: {
    index: number;
    onNext: () => void;
    onPrevious: () => void;
    slideCount: number;
    lastIndex: number;
}) => {
    const isLastIndex = index === lastIndex;

    return (
        <XStack gap={8} alignItems="center" justifyContent="space-between">
            <View
                cursor={index === 0 ? 'default' : 'pointer'}
                padding={8}
                justifyContent="center"
                alignItems="center"
                onPress={onPrevious}
            >
                <Icon
                    icon={ArrowLeft}
                    size={16}
                    color={index === 0 ? '$gray800' : '$black'}
                />
            </View>
            <LabelRegular userSelect="none">
                {index + 1}/{slideCount}
            </LabelRegular>
            <View
                cursor={isLastIndex ? 'default' : 'pointer'}
                padding={8}
                justifyContent="center"
                alignItems="center"
                onPress={onNext}
            >
                <Icon
                    icon={ArrowRight}
                    size={16}
                    color={isLastIndex ? '$gray800' : '$black'}
                />
            </View>
        </XStack>
    );
};
